<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h1>Reset Password</h1>
                <p class="text-muted">Enter the confirmation code and your new password</p>
                <hm-alert/>
                <b-form @submit.prevent="onSubmit">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-key"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      ref="code"
                      name="code"
                      type="text"
                      class="form-control"
                      placeholder="Confirmation Code"
                      v-model="code"
                      v-validate="'required'"
                      :disabled="!ready"
                      :class="{ 'is-invalid': errors.has('code') && submitted }"
                    />
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      ref="password"
                      name="password"
                      type="password"
                      class="form-control"
                      placeholder="Password - 10 character minimum"
                      aria-describedby="passwordFeedback"
                      v-model="password"
                      v-validate="'required|min:10'"
                      :disabled="!ready"
                      :class="{ 'is-invalid': errors.has('password') && submitted }"
                    />
                    <b-form-invalid-feedback id="passwordFeedback">Enter at least 10 characters</b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      ref="password-confirm"
                      name="password-confirm"
                      type="password"
                      class="form-control"
                      placeholder="Repeat password"
                      aria-describedby="passwordConfirmFeedback"
                      v-model="passwordconfirm"
                      v-validate="'required|confirmed:password'"
                      :disabled="!ready"
                      :class="{ 'is-invalid': errors.has('password-confirm') && submitted }"
                    />
                    <b-form-invalid-feedback id="passwordConfirmFeedback">Passwords must match</b-form-invalid-feedback>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="link" class="px-0" :disabled="!ready" @click="onResendCode">Resend code</b-button>
                      <br>
                      <b-button variant="link" class="px-0" :disabled="!ready" to="/login">Return to login</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button type="submit" variant="primary" class="px-4" :disabled="!ready">
                        <i class="fa fa-refresh fa-spin" v-if="!ready"></i>
                        Confirm
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
              <b-card-footer class="p-4">
                <hm-footer-logo/>
              </b-card-footer>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { authService } from '@/services';

export default {
  name: 'ForgotConfirm',
  props: ['email', 'codeParam'],
  data() {
    return {
      code: '',
      password: '',
      passwordconfirm: '',
      ready: true,
      submitted: false
    };
  },
  methods: {
    ...mapActions({
      alertClear: 'alert/clear',
      alertSuccess: 'alert/success',
      alertError: 'alert/error',
      alertException: 'alert/exception'
    }),
    onSubmit() {
      this.ready = false;
      this.submitted = true;
      this.alertClear();

      this.$validator.validate()
        .then(valid => {
          if (valid) {
            return authService.confirmPassword(this.email, this.code, this.password)
              .then(resp => {
                this.$gtag.event('forgot_pswd_confirm', { 'event_category': 'engagement' });
                this.$router.push({ name: 'Login', params: { email: this.email, msg: 'Password reset successful!' } });
              })
              .catch(err => {
                this.alertException({ err, message: 'Error resetting password, please try again.' });
              });
          } else {
            this.alertError('Please complete all information and submit again.');
          }
        })
        .finally(() => {
          this.ready = true;
        });
    },
    onResendCode() {
      this.ready = false;
      this.submitted = false;
      this.alertClear();

      return authService.forgotPassword(this.email)
        .then(resp => {
          this.alertSuccess('Code has been resent!');
        })
        .catch(err => {
          this.alertException({ err, message: 'Error sending code, please try again.' });
        })
        .finally(() => {
          this.ready = true;
        });
    }
  },
  created() {
    // check for code parameter and pre-seed value
    if (this.codeParam && this.codeParam.length > 0) {
      this.code = this.codeParam;
    }
  },
  watch: { // you have to use function syntax here, as warned in the docs
    '$route.params.codeParam': function (newVal, oldVal) {
      // check for code parameter and pre-seed value
      this.code = newVal;
    }
  }
}
</script>